import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import JsonViewer from "vue-json-viewer";
import Vuex from "vuex";
import 'vuejs-google-maps/dist/vuejs-google-maps.css'
import {D3LineChart} from 'vue-d3-charts'
import {library} from '@fortawesome/fontawesome-svg-core'
import {faFilePdf, faUserSecret} from '@fortawesome/free-solid-svg-icons'
import VueGoogleMap from "vuejs-google-maps";


Vue.use(VueGoogleMap, {
    load: {
        apiKey: (process.env.VUE_APP_API_GOOGLE_KEY) || "",
        libraries: [/* rest of libraries */]
    }
})


import {
    faBuilding,
    faMask,
    faSeedling,
    faFireExtinguisher,
    faStoreSlash,
    faVirus,
    faUmbrellaBeach,
    faIndustry,
    faHardHat,
    faCheck,
    faCircle,
    faHeartbeat,
    faUmbrella,
    faChair,
    faCar,
    faLaptopCode,
    faGavel,
    faMobileAlt,
    faBusAlt,
    faHandsHelping,
    faUserTie,
    faChevronDown,
    faDownload,
    faExclamationTriangle,
} from '@fortawesome/free-solid-svg-icons'

import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'




Vue.use(D3LineChart);

Vue.use(JsonViewer);
Vue.use(Vuex);
library.add(faBuilding)
library.add(faMask)
library.add(faSeedling)
library.add(faFireExtinguisher)
library.add(faStoreSlash)
library.add(faVirus)
library.add(faUmbrellaBeach)
library.add(faIndustry)
library.add(faHardHat)
library.add(faUserSecret)
library.add(faHeartbeat)
library.add(faCircle)
library.add(faCheck)
library.add(faUmbrella)
library.add(faChair)
library.add(faCar)
library.add(faLaptopCode)
library.add(faGavel)
library.add(faMobileAlt)
library.add(faBusAlt)
library.add(faHandsHelping)
library.add(faUserTie)
library.add(faChevronDown)
library.add(faDownload)
library.add(faExclamationTriangle)
library.add(faFilePdf)


Vue.component('font-awesome-icon', FontAwesomeIcon)


Vue.config.productionTip = false;

Vue.mixin({
    methods: {
        scrollMeTo(refName) {
            //var element = this.$els[refName];
            //element.scrollIntoView({ behavior: 'smooth' });
            var target = document.getElementById(refName)

            if (target != null) {
                try {
                    document.querySelectorAll('a.anchor').forEach(el => el.style.visibility="hidden");
                } catch (e) {
                    console.log("error hidding targets")
                }
                target.style.visibility = "visible"
                //target.scrollIntoView({ behavior: 'smooth',   block: 'start' });

                const y = target.getBoundingClientRect().top + window.pageYOffset - 100;
                window.scrollTo({top: y, behavior: 'smooth'});

            }
        }
    },
})




new Vue({
    router: router,
    store,
    vuetify,
    render: (h) => h(App),
     mounted:function(){
        this.start() //method1 will execute at pageload
    },
    methods:{
        start:function(){
             store.dispatch('getUserInfo');
        }
     },
}).$mount("#app");
